export enum MicroserviceType {
  Service = 0,
  Product = 1,
}
export const getMicroserviceType = (type: string): number => {
  return MicroserviceType[type as keyof typeof MicroserviceType]
}
